import { Link, Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { vrpcNoteTranslation } from './translation';
import { useVrpcNoteStyles } from './useVrpcNoteStyles';

export const VRPC_DOCS_URL =
  'https://www.ankr.com/docs/verifiable-rpc/quickstart/';

export const VrpcNote = () => {
  const { classes } = useVrpcNoteStyles();
  const { keys, t } = useTranslation(vrpcNoteTranslation);

  return (
    <div className={classes.root}>
      <Typography variant="body3" color="textSecondary">
        {t(keys.why)}
      </Typography>
      <Typography variant="body3" color="textSecondary">
        {t(keys.how)} {t(keys.price)}{' '}
        <Link
          href={VRPC_DOCS_URL}
          rel="noopener noreferrer"
          target="_blank"
          variant="body3"
        >
          {t(keys.docs)}
        </Link>
      </Typography>
    </div>
  );
};
